module.exports = __webpack_public_path__ + "static/media/image.12577e80.png";